import {
  USER_ADD_COMPANY_FAIL,
  USER_ADD_COMPANY_REQUEST,
  USER_ADD_COMPANY_RESET,
  USER_ADD_COMPANY_SUCCESS,
  USER_GET_MY_COMPANIES_FAIL,
  USER_GET_MY_COMPANIES_REQUEST,
  USER_GET_MY_COMPANIES_SUCCESS,
  USER_GET_MY_DEPARTMENT_FAIL,
  USER_GET_MY_DEPARTMENT_REQUEST,
  USER_GET_MY_DEPARTMENT_SUCCESS,
  ALL_USER_FROM_COMPANY_LIST_FAIL,
  ALL_USER_FROM_COMPANY_LIST_REQUEST,
  ALL_USER_FROM_COMPANY_LIST_SUCCESS,
  GET_COMPANY_OWNER_FAIL,
  GET_COMPANY_OWNER_REQUEST,
  GET_COMPANY_OWNER_SUCCESS,
  CHANGE_USER_COMPANY_REQUEST,
  CHANGE_USER_COMPANY_SUCCESS,
  GET_USER_COMPANIES_REQUEST,
  GET_USER_COMPANIES_SUCCESS,
  GET_USER_COMPANIES_FAIL,
  CHANGE_USER_COMPANY_FAIL,
} from "../../types/user/companyTypes";

export const addCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ADD_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_ADD_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        companyAddInfo: payload,
        error: "",
      };
    case USER_ADD_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        companyAddInfo: {},
      };
    case USER_ADD_COMPANY_RESET:
      return {
        loading: false,
        error: "",
        companyAddInfo: {},
      };
    default:
      return state;
  }
};

export const getMyCompaniesReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_GET_MY_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_GET_MY_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        getMyDepart: payload,
        error: "",
      };
    case USER_GET_MY_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        getMyDepart: [],
      };
    default:
      return state;
  }
};

export const getMyDepartReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_GET_MY_COMPANIES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_GET_MY_COMPANIES_SUCCESS:
      return {
        ...state,
        loading: false,
        getMyEnrollCompanies: payload,
        error: "",
      };
    case USER_GET_MY_COMPANIES_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        getMyEnrollCompanies: [],
      };
    default:
      return state;
  }
};

export const getAllCompaniesReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ALL_USER_FROM_COMPANY_LIST_REQUEST:
      return {
        ...state,
        userCompanyLoading: true,
      };
    case ALL_USER_FROM_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        userCompanyLoading: false,
        userCompanyInfo: payload,
        userCompanyError: "",
      };
    case ALL_USER_FROM_COMPANY_LIST_FAIL:
      return {
        ...state,
        userCompanyLoading: false,
        userCompanyError: payload,
        userCompanyInfo: [],
      };
    default:
      return state;
  }
};

export const getCompanyOwnerReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_COMPANY_OWNER_REQUEST:
      return {
        ...state,
        getCompanyOwnerLoading: true,
      };
    case GET_COMPANY_OWNER_SUCCESS:
      return {
        ...state,
        getCompanyOwnerLoading: false,
        getCompanyOwnerInfo: payload,
        getCompanyOwnerError: "",
      };
    case GET_COMPANY_OWNER_FAIL:
      return {
        ...state,
        getCompanyOwnerLoading: false,
        getCompanyOwnerError: payload,
        getCompanyOwnerInfo: [],
      };
    default:
      return state;
  }
};
export const getUserCompaniesReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_USER_COMPANIES_REQUEST:
      return {
        ...state,
        getUserCompaniesLoading: true,
      };
    case GET_USER_COMPANIES_SUCCESS:
      return {
        ...state,
        getUserCompaniesLoading: false,
        getUserCompaniesInfo: payload,
        getUserCompaniesError: "",
      };
    case GET_USER_COMPANIES_FAIL:
      return {
        ...state,
        getUserCompaniesLoading: false,
        getUserCompaniesError: payload,
        getUserCompaniesInfo: [],
      };
    default:
      return state;
  }
};
export const changeUserCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case CHANGE_USER_COMPANY_REQUEST:
      return {
        ...state,
        changeUserCompanyLoading: true,
      };
    case CHANGE_USER_COMPANY_SUCCESS:
      return {
        ...state,
        changeUserCompanyLoading: false,

        changeUserCompanyInfo: payload,

        changeUserCompanyError: "",
      };
    case CHANGE_USER_COMPANY_FAIL:
      return {
        ...state,
        changeUserCompanyLoading: false,
        changeUserCompanyError: payload,
        changeUserCompanyInfo: [],
      };
    default:
      return state;
  }
};
